module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-tab-menu-item",
    class: {
      'active': _vm.active
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.switchMenu(_vm.tab.id)
      }
    }
  }, [_c('div', {
    staticClass: "el-tab-menu-item-link"
  }, [_c('router-link', {
    staticClass: "el-tab-menu-item-link",
    attrs: {
      "to": _vm.tab.path
    }
  }, [_vm._v(_vm._s(_vm.tab.name))])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "close"
    }
  }, [_c('div', {
    staticClass: "el-tab-menu-close el-icon-close2"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-381ce9c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab-menu/src/tab-menu-item.vue
// module id = 632
// module chunks = 0